import React from 'react';
import { CecoMenu } from 'assets/icons';
import { useApp } from 'context/AppProvider';
import classNames from 'classnames';
import Portal from 'components/Portal/Portal';
import './Header.scss';

export default function Header(props) {
  const { setMenuIsOpen, menuIsOpen } = useApp();
  const { title, leftComponent, rightComponent } = props;

  return (
    <header className={classNames('header', props.className)}>
      {title ? (
        <div className="header__title">
          <CecoMenu onClick={() => setMenuIsOpen(!menuIsOpen)} />
          <h1>{title}</h1>
        </div>
      ) : (
        <>
          {leftComponent && <div className="header__left">{leftComponent}</div>}
          <Portal.Out name="page-header-left" />
        </>
      )}
      <>
        {rightComponent && (
          <div className="header__right">{rightComponent}</div>
        )}
        <Portal.Out name="page-header-right" />
      </>
    </header>
  );
}
